import * as React from 'react';
import { createContext, useContext, useState } from 'react';
import { Announcement } from '../../announcements/components/AnnouncementBar.tsx';

interface ApplicationContextProps {
    loading?: boolean;
    channelId?: any;
    setChannelId?: (channel: any) => void;
    user: any;
    refetchUser: any;
    announcements?: Announcement[];
    navigationHistory?: any;
    setNavigationHistory?: (history: any) => void;
    children: any;
}

const ApplicationContext = createContext<Omit<ApplicationContextProps, 'children'>>({
    loading: false,
    channelId: null,
    setChannelId: () => {},
    user: null,
    refetchUser: null,
    announcements: [],
    navigationHistory: [],
});

export const ApplicationContextProvider = (props: Omit<ApplicationContextProps, 'navigationHistory'>) => {
    const { children, ...value } = props;
    const [navigationHistory, setNavigationHistory] = useState<any[]>([]);
    return (
        <ApplicationContext.Provider value={{ ...value, navigationHistory }}>{children}</ApplicationContext.Provider>
    );
};

export const useApplicationContext = () => useContext(ApplicationContext);
